<app-header-modal [color]="'secondary-2'" title="{{title}}">
  <div icon *ngIf="isPallet || showEditLevelComponent">
    <i class="uil uil-arrow-left" (click)="goBackToMap()"></i>
  </div>
  <div class="status-header" status *ngIf="isPallet">
    <app-status-header-modal [icon]="'check'" [color]="'success'" [status]="'Conferido'"></app-status-header-modal>
    <i class="uil uil-times" (click)="close()"></i>
  </div>
</app-header-modal>
<app-stock-levels-modal *ngIf="isPosition"
  [data]="data"
  (changeToPallet)="onChangeToPallet($event)"
  (changeToPalletOnHistory)="onChangeToPallet($event, 1)"
  (changeToPalletOnComments)="onChangeToPallet($event, 2)"
  (closeModal)="close()"
  (inventoryClicked)="onMapInventoryClicked($event)"
  (changeToEditLevel)="onChangeToEditLevel($event)"
  (palletInventoryClicked)="onListPalletInventoryClicked($event)"
  (palletRelocateClicked)="onListPalletRelocateClicked($event)">
</app-stock-levels-modal>
<app-level-details *ngIf="showEditLevelComponent"
  [level]="levelToEdit"
  [position]="positionToEdit"
  (closeModal)="goBackToMap()">
</app-level-details>
<app-map-pallet-details *ngIf="isPallet"
  [data]="palletDetails"
  (relocateClicked)="onRelocateClicked($event)"
  (palletInventoryClicked)="onPalletInventoryClicked($event)"
  (closeModal)="close()">
</app-map-pallet-details>

